import React from 'react';
import DataSourceCard from './DataSourceCard';

function DataSources({ isLoading, savedsources, setConductReload }) {

    if (isLoading) {
        return (
            <div className="flex justify-center items-center" style={{ height: '100px' }}>
                <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" role="status"></div>
                <span className="ml-2 font-semibold text-xl text-gray-900 dark:text-white">Loading Active Data Sources...</span>
            </div>
        );
    }

    if (savedsources.length === 0) {
        return (
            <div className="flex justify-center mt-3">
                <div className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded" role="alert">
                    No Active Data Sources, Click Above To Add A Configuration
                </div>
            </div>
        );
    }

    let rows = [];
    for (let i = 0; i < savedsources.length; i += 3) {
        rows.push(
            <div key={i} className="flex flex-wrap mx-2">
                {savedsources.slice(i, i + 3).map((savedsource, index) => (
                    <DataSourceCard key={index} savedsource={savedsource} setConductReload={setConductReload} />
                ))}
            </div>
        );
    }
    return rows;
}

export default DataSources;
